import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../../../components/custom-table/custom-table";
import { LoaderMessage } from "../../../../components/loaderMessage/loaderMessage";
import SideModal from "../../../../components/modals/filterModal/filterModal";
import { useDataAccumulatorForSingleOrder } from "../../../../context/dataAccumulatorForSingleOrder";
import { getAuditTrialDetails } from "../../../../redux/slice/auditTrialSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import {
  AuditTrialTableColumnHeaders,
  generateAuditTrialTableData,
} from "../../utils/auditTrialTableDataGenerator";
import AuditTrialSubEvents from "../auditTrialSubEvents/auditTrialSubEvents";

/**
 * Audit trail tab for the external single-order page.
 * Loads event overview data via the {@link useDataAccumulatorForSingleOrder} context
 * and renders a read-only {@link CustomTable} with a "View All" drill-down.
 */
const AuditTrial = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { auditTrialOverview, isLoading } = useSelector(
    (state: RootState) => state.auditTrialOverview,
  );

  // const { singleMedicalPaOrder } = useSelector(
  //   (state: RootState) => state.singleMedicalPaOrder,
  // );
  const { generalOrderDetails } = useDataAccumulatorForSingleOrder();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    if (auditTrialOverview && generalOrderDetails) {
      const data = generateAuditTrialTableData(
        auditTrialOverview.entries ?? [],
        generalOrderDetails?.order ?? {},
      );
      setTableData(data);
    }
  }, [auditTrialOverview, generalOrderDetails]);

  return (
    <div className="audit-trial--container h-full">
      {isLoading ? (
        <>
          <div className="loader-message--container flex h-full items-center justify-center">
            <LoaderMessage message="Loading audit trial..." />
          </div>
        </>
      ) : (
        <>
          <CustomTable
            showOtherButton={true}
            otherButtonMeta={{
              text: "View All",
              onClick: () => {
                navigate(
                  `/external-worklist/view-all-events/${generalOrderDetails?.order?.order_id}`,
                );
              },
              disabled: false,
              buttonType: "secondary",
              size: "medium",
            }}
            tableHeaders={AuditTrialTableColumnHeaders}
            tableData={tableData}
            tableName="audit_trial"
            pagesPerView={5}
            itemsPerPage={tableData.length}
            count={tableData.length}
            hideSearchBar={true}
            hidePagination={true}
            onRowClick={(data) => {
              setIsModalOpen(true);
              dispatch(
                getAuditTrialDetails(
                  data.rowData.order_id,
                  data.rowData.name,
                  data.rowData.tag,
                ),
              );
            }}
          />
          {isModalOpen && (
            <>
              {" "}
              <SideModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                width="50%"
                children={
                  <AuditTrialSubEvents onClose={() => setIsModalOpen(false)} />
                }
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default AuditTrial;
